module.exports = __webpack_public_path__ + "static/media/monkey-black.34f12d7a.png";